module.exports = __webpack_public_path__ + "static/media/adobo.bef34361.png";